import { IFileEntity } from '@app/pages/cmms/interfaces/files.interfaces';
import { createAction, props } from '@ngrx/store';

export const setImportedFiles = createAction(
	'[FILES-IMPORT] Set Imported Files',
	props<{ files: IFileEntity[] }>()
);
export const addImportedFiles = createAction(
	'[FILES-IMPORT] Add Imported Files',
	props<{ files: IFileEntity[] }>()
);
export const removeImportedFiles = createAction(
	'[FILES-IMPORT] Remove Imported Files',
	props<{ pks: string[] }>()
);
export const updateImportedFiles = createAction(
	'[FILES-IMPORT] Update Imported Files',
	props<{ files: Partial<IFileEntity>[] }>()
);
